import { CommonModule } from '@angular/common'
import { Component, inject, type OnInit, ChangeDetectionStrategy } from '@angular/core'
import { NavigationEnd, RouterModule, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { filterMenuByPermissions, HORIZONTAL_MENU_ITEM, type MenuItemType } from '@common/menu-meta'
import { findAllParent, findMenuItem } from '@core/helper/utils'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { selectPermissions } from '@/store/authentication/authentication.selector'

@Component({
  selector: 'horizontal-nav',
  standalone: true,
  imports: [CommonModule, RouterModule, NgbDropdownModule],
  templateUrl: './horizontal-nav.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class HorizontalNavComponent implements OnInit {
  menuItems: MenuItemType[] = []
  activeMenuItems: string[] = []

  private store = inject(Store)

  constructor(router: Router) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenu()
      }
    })
  }

  ngOnInit(): void {
    // Permission-gated entries (e.g. Audit trail, FEAT-0004 AC-5) render only for holders. UX only —
    // the route guard and the API re-enforce.
    this.store.select(selectPermissions).subscribe((permissions) => {
      this.menuItems = filterMenuByPermissions(HORIZONTAL_MENU_ITEM, permissions)
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this._activateMenu()
    })
  }

  /**
   * activate the menuitems
   */
  _activateMenu(): void {
    const div = document.getElementById('topnav-menu-content')
    let matchingMenuItem = null
    if (div) {
      let items: HTMLCollectionOf<HTMLAnchorElement> =
        div.getElementsByClassName(
          'nav-link-ref'
        ) as HTMLCollectionOf<HTMLAnchorElement>
      for (let i = 0; i < items.length; ++i) {
        if (window.location.pathname === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }

      if (matchingMenuItem) {
        const mid = matchingMenuItem.getAttribute('data-menu-key')
        const activeMt = findMenuItem(this.menuItems, mid!)
        if (activeMt) {
          this.activeMenuItems = [
            activeMt['key']!,
            ...findAllParent(this.menuItems, activeMt),
          ]
        }
      }
    }
  }

  hasSubmenu(menu: MenuItemType): boolean {
    return menu.children ? true : false
  }
}
